import _fetch from '@avalara/bat-apps-shared/lib/client-fetch';

import { isOneWebDomainRuntime } from '../helpers';
import { checkIsAuthenticated } from './helpers';

/** Net-new trial offers do not require a bearer token for BFF calls. */
export const isNetNewTrialOfferPath = (): boolean =>
  /\/buy\/(free-trial|avatax-free-trial)(\/|$)/.test(window.location.pathname);

type TokenCacheState = {
  token: string | null;
  resolved: boolean;
};

let tokenCache: TokenCacheState = { token: null, resolved: false };

export const resetOwdBearerTokenCache = (): void => {
  tokenCache = { token: null, resolved: false };
};

export const getOwdBearerToken = async (): Promise<string | null> => {
  if (!isOneWebDomainRuntime() || !checkIsAuthenticated() || isNetNewTrialOfferPath()) {
    return null;
  }

  if (tokenCache.resolved) {
    return tokenCache.token;
  }

  tokenCache.resolved = true;

  const accessTokenRes = await _fetch<{ accessToken: string }>({
    url: `${window.AvaAppConfig?.hostnames.avaApp}/api/token`,
    params: { credentials: 'include' },
  });

  tokenCache.token = accessTokenRes.ok && accessTokenRes.value.accessToken ? accessTokenRes.value.accessToken : null;

  return tokenCache.token;
};
